import React from "react";
import ReactECharts from "echarts-for-react";
import { toTimestamp, formatDateFr } from "../../utils/echartsSeries.js";
import { HORIZON_COLORS } from "../../constants.js";

export default function PhenoChart({ data }) {
  // Regroupe par horizon (2020/2035/2050) en gardant les champs is_reco /
  // Libelle_SP nécessaires pour les étiquettes — groupSeriesXY ne suffit
  // pas ici car il ne conserve que x/y.
  const byGroup = new Map();
  data.forEach((row) => {
    if (!byGroup.has(row.YearGroup)) byGroup.set(row.YearGroup, []);
    byGroup.get(row.YearGroup).push(row);
  });

  const series = Array.from(byGroup.entries()).map(([group, rows]) => {
    const sorted = [...rows].sort((a, b) => (a.date_calendaire > b.date_calendaire ? 1 : -1));
    const points = sorted.map((r) => {
      // Étiquette uniquement pour les stades "recommandés" (is_reco, envoyé
      // par l'API) et uniquement sur l'horizon 2050.
      const showLabel = r.is_reco && String(group) === "2050";
      const point = { value: [toTimestamp(r.date_calendaire), r.GDD_VF] };
      if (showLabel) {
        point.label = {
          show: true,
          formatter: r.Libelle_SP,
          position: "left",
          fontWeight: "bold",
        };
      }
      return point;
    });

    return {
      name: String(group),
      type: "line",
      smoothed: true,
      symbol: "circle",
      symbolSize: 8,
      // nécessaire pour que le label défini par point (ci-dessus) soit pris
      // en compte par ECharts ; sans ce label "de base" au niveau série,
      // certaines versions d'ECharts ignorent le label par point.
      label: { show: false },
      lineStyle: { width: 2.5, color: HORIZON_COLORS[group] || "#888" },
      itemStyle: { color: HORIZON_COLORS[group] || "#888" },
      data: points,
    };
  });

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "cross", label: { show: false } },
      valueFormatter: (v) => `${v} GDD`,
      formatter: (params) => {
        const date = formatDateFr(params[0].value[0]);
        let html = `${date}<br/>`;
        params.forEach((p) => {
          html += `${p.marker} ${p.seriesName}: ${p.value[1]} GDD<br/>`;
        });
        return html;
      },
    },
    legend: { bottom: 0, textStyle: { fontSize: 16 } },
    grid: { left: 60, right: 20, top: 20, bottom: 60, containLabel: true },
    xAxis: { type: "time", axisLabel: { formatter: formatDateFr } },
    yAxis: { type: "value", name: "GDD VF", nameLocation: "middle", nameGap: 45 },
    series,
  };

  return <ReactECharts option={option} style={{ height: 500 }} notMerge lazyUpdate />;
}
